"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAPreOrderItemDetailsComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const shared_1 = require("../../../../mma/shared");
const orderStatus_service_1 = require("../../../services/orderStatus.service");
const constants = require("../../../util/constants");
class CSMMAPreOrderItemDetailsComponent {
    constructor(orderService, modalService, genericContentService) {
        this.orderService = orderService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.refreshPreorderDetailsEmitter = new core_1.EventEmitter();
        this.modalErrorEmitter = new core_1.EventEmitter();
    }
    ngOnChanges() {
        if (this.isCancellingPreorder) {
            this.cancelEntirePreorder();
        }
    }
    openCancelLineItemModal(deviceId) {
        this.modalError = null;
        this.deviceLineItemId = deviceId;
        this.modelRef = this.modalService.open(this.modalCancelLineItem, { centered: true });
    }
    editOrder() {
        this.modalError = null;
        if ((this.isVerifiedUser || this.isLoggedInUser) && this.preOrderData) {
            this.getCartCount();
        }
    }
    editProrderDetails() {
        this.modalError = null;
        this.modalLoader = true;
        const formData = {
            'preOrderInfo': this.preorderInfo
        };
        this.orderService.editPreorderDetails(formData).subscribe((res) => {
            window.location.href = constants.cartUrl;
        }, (error) => {
            this.modalError = error;
            this.modalLoader = false;
        });
    }
    /*
    * @return Check for existing cart item
    */
    getCartCount() {
        this.modalLoader = true;
        this.orderService.getCartCount().subscribe((count) => {
            this.cartItemCount = count.itemCount;
            this.openEditPreorderModal();
            this.modalLoader = false;
        });
    }
    showDPPCreditInfo() {
        this.modalLoader = true;
        this.modelRef = this.modalService.open(this.modalDPPCreditInfo, { centered: true });
        this.genericContentService.getGenericContent('genericContentForPromoCredit').subscribe((data) => {
            this.dppPromoCreditInfo = data.contentText;
            this.modalLoader = false;
        }, (err) => {
            this.modalError = err;
            this.modalLoader = false;
        });
    }
    openEditPreorderModal() {
        if (this.cartItemCount > 0) {
            this.modelRef = this.modalService.open(this.modalClearCart, { centered: true });
        }
        else {
            this.modelRef = this.modalService.open(this.modalEditPreorder, { centered: true });
        }
    }
    /*
    * @return Clear cart
    */
    clearCart() {
        this.modalLoader = true;
        this.orderService.clearCart().subscribe((data) => {
            window.location.reload();
        }, (error) => {
            this.modalError = error;
            this.modalLoader = false;
        });
    }
    deleteLineItem() {
        this.modalError = null;
        this.modalLoader = true;
        const formData = this.prepareFormData(true, false);
        this.deleteItem(formData, 'false');
    }
    setAccessoryLineItemId(event) {
        this.accessoryLineItemId = event;
    }
    cancelAccessory(event) {
        if (event) {
            this.modalLoader = true;
            const formData = this.prepareFormData(false, true);
            this.deleteItem(formData, 'true');
        }
    }
    cancelEntirePreorder() {
        this.modalLoader = true;
        const formData = this.prepareFormData(false, false);
        this.deleteItem(formData, 'false');
    }
    prepareFormData(isDevice, isAccessory) {
        const formData = {
            'preOrderId': this.preOrderData.preorderId,
            'lineItemStatus': constants.customerCancel
        };
        if (isDevice) {
            formData['lineItemId'] = this.deviceLineItemId;
        }
        else if (isAccessory) {
            formData['lineItemId'] = this.accessoryLineItemId;
        }
        return formData;
    }
    deleteItem(formData, isCancelOnlyAccessory) {
        this.orderService.cancelPreorder(formData, isCancelOnlyAccessory).subscribe((cancelResponse) => {
            if (cancelResponse.preorderId === this.preOrderData.preorderId) {
                this.modalLoader = false;
                this.refreshPreorderDetailsEmitter.emit(true);
                this.modelRef = this.modalService.dismissAll();
            }
        }, (err) => {
            this.modalError = err;
            this.modalErrorEmitter.emit(err);
            this.modalLoader = false;
        });
    }
    calculateDPPPrice(preorderItem) {
        let devicePrice = Number(preorderItem.estimatedPrice);
        if (!isNaN(preorderItem === null || preorderItem === void 0 ? void 0 : preorderItem.mandatoryDownPayment)) {
            devicePrice = devicePrice - preorderItem.mandatoryDownPayment;
        }
        if (!isNaN(preorderItem === null || preorderItem === void 0 ? void 0 : preorderItem.voluntaryDownPayment)) {
            devicePrice = devicePrice - preorderItem.voluntaryDownPayment;
        }
        if (!isNaN(preorderItem === null || preorderItem === void 0 ? void 0 : preorderItem.discountsApplied)) {
            devicePrice = devicePrice - preorderItem.discountsApplied;
        }
        devicePrice = devicePrice / Number(preorderItem.dppTermLength);
        return devicePrice > 0 ? devicePrice : 0;
    }
    ngOnDestroy() {
        this.modelRef = this.modalService.dismissAll();
    }
}
exports.CSMMAPreOrderItemDetailsComponent = CSMMAPreOrderItemDetailsComponent;
//# sourceMappingURL=preorder-item-details.component.js.map